module.exports = __webpack_public_path__ + "static/img/m_pad.e02b358.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/m_pad.png
// module id = T8zB
// module chunks = 1